import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useScript from 'react-script-hook';
import useStyles from 'isomorphic-style-loader/useStyles';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import CloseIcon from '@material-ui/icons/Close';

import CssInstagramModal from './InstagramModal.scss';

function InstagramModal(props) {
  const { open, onClose, maxWidth, html } = props;
  useStyles(CssInstagramModal);
  useScript({
    src: open ? 'https://platform.instagram.com/en_US/embeds.js' : null,
    async: true,
    checkForExisting: true,
  });

  useEffect(() => {
    if (window.instgrm && open) {
      setTimeout(window.instgrm.Embeds.process, 0);
    }
  });

  return (
    <Modal onClose={onClose} open={open}>
      <div className="instagram-modal" role="none" onClick={onClose}>
        <div role="dialog" className="instagram-modal__wrapper" style={{ maxWidth }}>
          <div className="instagram-modal__close">
            <IconButton aria-label="close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <Paper
            className="instagram-modal__content" // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: html,
            }}
          />
        </div>
      </div>
    </Modal>
  );
}

InstagramModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  maxWidth: PropTypes.number,
  html: PropTypes.string.isRequired,
};

InstagramModal.defaultProps = {
  onClose: () => {},
  maxWidth: 640,
};

export default React.memo(InstagramModal);
